/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import React from 'react';
import { observer } from 'mobx-react';
import { ReactComponent as OpenSearchIcon } from 'Assets/svg/open-search.svg';
import { ReactComponent as SaveSearchIcon } from 'Assets/svg/save-search.svg';
import { ReactComponent as EditIcon } from 'Assets/svg/edit.svg';
import { ReactComponent as DeleteIcon } from 'Assets/svg/delete-to.svg';
import { confirmationPopupState } from 'Components/common/confirmationPopup';
import advSearchState from 'Stores/advSearch';
import companySearchState from 'Stores/companySearch';
import userDetail from 'Stores/userDetail';
import Utils from 'Utils/utils';
import * as CONSTANTS from 'Utils/constants';
import { createSaveSearchState } from './createSaveSearch';

const SaveSearchComponent = observer(props => {
  const { currentTab } = props;

  let currentSelectedState;
  if (currentTab === 'contact') currentSelectedState = advSearchState;
  else currentSelectedState = companySearchState;

  const [showSavedSuggestion, setShowSavedSuggestion] = React.useState(false);

  const [suggestionList, setSuggestionList] = React.useState([]);
  const [searchName, setSearchName] = React.useState('');
  const [savedSearchId, setSavedSearchId] = React.useState('');
  const [showSaveSearch, setShowSaveSearch] = React.useState(false);
  const closeSuggestion = e => {
    if (e !== null && e !== undefined) e.stopPropagation();
    if (document !== undefined)
      document
        .getElementsByClassName('left-section')[0]
        .classList.remove('stop-scroll');
    setShowSavedSuggestion(false);
  };

  if (
    searchName === '' &&
    props.templateName !== '' &&
    window.location.hash !== '#search'
  )
    setSearchName(props.templateName);

  if (
    savedSearchId === '' &&
    props.savedSearchId !== '' &&
    window.location.hash !== '#search'
  )
    setSavedSearchId(props.savedSearchId);

  const selectSavedSearch = (e, searchTemplate, appliedSearchName, id) => {
    setSearchName(appliedSearchName);
    setSavedSearchId(id);
    // Utils.setLocalStorage('searchJson', JSON.parse(searchTemplate));
    closeSuggestion(e);
    setShowSaveSearch(false);
    if (window.location.hash === '#search')
      window.history.replaceState(null, null, `${window.location.pathname}`);
    if (searchTemplate !== undefined && searchTemplate !== null) {
      Utils.mixpanelTrack(CONSTANTS.MX_AS_EVENTS.AS_OPEN_SAVED_SEARCH, {
        searchName: appliedSearchName,
      });
      const searchJson = JSON.parse(searchTemplate);
      if (searchJson.limit !== undefined && searchJson.limit > 100)
        searchJson.limit = 50;
      currentSelectedState.applySearch(searchJson, true);
    }
  };

  const saveThisSearch = () => {
    const appFilter = currentSelectedState.appliedFilterSectionData;
    if (Object.keys(appFilter).length) {
      const callback = data => {
        if (data.searchTemplate !== undefined)
          selectSavedSearch(
            null,
            null,
            data.searchTemplate.templateName,
            data.searchTemplate.id,
          );
      };
      Utils.mixpanelTrack(CONSTANTS.MX_AS_EVENTS.AS_SAVE_SEARCH_CLICKED, {});

      createSaveSearchState.setActionMethod('create');
      createSaveSearchState.setCallback(callback);
      createSaveSearchState.setSearchType(currentTab);
      createSaveSearchState.setShowCreateSaveSearch(true);
    }
  };

  const editThisSearch = (e, id, name, frequency) => {
    if (e !== null && e !== undefined) e.stopPropagation();

    closeSuggestion(e);
    createSaveSearchState.setActionMethod('update');
    createSaveSearchState.setSearchType(currentTab);
    createSaveSearchState.setUpdateValues({
      id,
      name,
      emailFrequency: frequency,
    });
    createSaveSearchState.setShowCreateSaveSearch(true);
  };

  const deleteThisSearch = (e, id, name, frequency) => {
    if (e !== null && e !== undefined) e.stopPropagation();

    closeSuggestion();
    const callback = () => {
      if (id === savedSearchId) {
        setSearchName('');
        setSavedSearchId('');
        currentSelectedState.applySearch({});
      }
      currentSelectedState.deleteSavedSearch(id);
    };
    confirmationPopupState.setPopupValues({
      title: 'Delete Saved Search',
      content: `Are you sure? This will delete the search template <b>${name}</b>.`,
      actionBtnText: 'Delete',
      callback,
    });
    confirmationPopupState.setShowPopup(true);
  };

  const renderList = () => {
    return suggestionList.map((item, index) => {
      return (
        <div
          key={`${currentTab}savedSearches${index}`}
          className={`suggestion-item${
            item.id === savedSearchId ? ' selected' : ''
          }`}
          title={item.templateName}
          data-name={item.id}
          onClick={e =>
            selectSavedSearch(
              e,
              item.searchTemplate,
              item.templateName,
              item.id,
            )
          }
        >
          <div className="saved-item show-elipsis">{item.templateName}</div>

          <div className="saved-search-manage">
            <EditIcon
              className="svg-icon"
              onClick={e =>
                editThisSearch(
                  e,
                  item.id,
                  item.templateName,
                  item.emailFrequency,
                )
              }
            />

            <DeleteIcon
              className="svg-icon"
              onClick={e =>
                deleteThisSearch(
                  e,
                  item.id,
                  item.templateName,
                  item.emailFrequency,
                )
              }
            />
          </div>
        </div>
      );
    });
  };

  const showSuggestion = e => {
    if (e !== null && e !== undefined) e.stopPropagation();
    setShowSavedSuggestion(true);
  };

  React.useEffect(() => {
    let currentSearch;
    if (currentTab === 'contact')
      currentSearch = userDetail.contactSavedSearches;
    else currentSearch = userDetail.companySavedSearches;

    setSuggestionList(currentSearch);
    const templateName = currentSearch.filter(item => {
      if (item.id === savedSearchId) return item.templateName;
    });

    if (templateName !== undefined && templateName.length > 0)
      setSearchName(templateName[0].templateName);
  }, [
    userDetail.contactSavedSearches,
    userDetail.companySavedSearches,
    currentTab,
  ]);

  React.useEffect(() => {
    if (
      currentSelectedState.resultStatusMsg === 'empty' ||
      currentSelectedState.resultStatusMsg === 'one_more'
    )
      setShowSaveSearch(false);
    else setShowSaveSearch(true);
    if (
      window.location.hash === '#search' ||
      Object.keys(currentSelectedState.appliedFilterPostData).length === 0
    ) {
      setSearchName('');
      setSavedSearchId('');
    } else {
      setShowSaveSearch(false);
    }
  }, [currentSelectedState.appliedFilterPostData]);

  return (
    <div className="save-search-wrapper">
      <div className="save-search open-search" onClick={showSuggestion}>
        <div className="saved-search">
          <OpenSearchIcon className="svg-icon" />
          <div className="show-elipsis">
            {searchName === '' ? 'Saved Searches' : searchName}
          </div>
          <i className="fa fa-angle-down dropdown-icon" />
        </div>
        <div
          className={`save-suggestion-list animatedFast animatedDropDown ${
            showSavedSuggestion ? '' : 'hide-suggestion'
          }`}
        >
          {suggestionList.length > 0 ? (
            <>
              <div className="suggestion-list-wrap">{renderList()}</div>
            </>
          ) : (
            <div className="suggestion-list-wrap">
              <div className="suggestion-item no-match-found">
                {
                  'Create your saved search and get notified when new leads are added'
                }
              </div>
            </div>
          )}
        </div>
        {showSavedSuggestion && (
          <div className="suggestion-mask" onClick={closeSuggestion} />
        )}
      </div>
      {showSaveSearch ? (
        <div className="save-search" onClick={saveThisSearch}>
          <SaveSearchIcon className="svg-icon" />
          <span>Save Search</span>
        </div>
      ) : (
        <div className="save-search btn-disabled">
          {' '}
          <SaveSearchIcon className="svg-icon" />
          <span>Save Search</span>
        </div>
      )}
    </div>
  );
});

export { SaveSearchComponent };
export default SaveSearchComponent;
